module.exports = __webpack_public_path__ + "img/mercantile.e6727211.png";